import { gql } from '@apollo/client';

export const GET_FREE_TIME = gql`
  query Query($input: ReadFreeTimeInput) {
    readFreeTime(input: $input)
  }
`;
